import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MR',
  name: 'Marcelo R.',
  location: 'San Justo, Buenos Aires',
  quote: 'Fui al corralón con el cómputo del Tomo 5 y por primera vez salí sin que me tomaran de sorpresa. El albañil se sorprendió de que yo supiera más que él.'
}, {
  initials: 'DF',
  name: 'Daniela y Facundo',
  location: 'Moreno, Buenos Aires',
  quote: 'Teníamos el terreno hace tres años y siempre encontrábamos una excusa para no arrancar. Con el Tomo 1 entendimos que podíamos empezar con 35m² y crecer en etapas. Hoy estamos en el Tomo 3.'
}, {
  initials: 'VC',
  name: 'Valeria C.',
  location: 'Quilmes, Buenos Aires',
  quote: 'El Layout Perfecto me salvó de un error enorme. Iba a poner la ventana de la cocina en el lugar equivocado. Lo cambié antes de construir — si no lo descubría ahí, lo pagaba en la obra.'
}];
export function TestimonialsCarousel() {
  return <section className="py-16 bg-white" data-id="element-355">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-356">
        <div className="flex overflow-x-auto pb-8 -mx-4 px-4 sm:mx-0 sm:px-0 gap-6 snap-x snap-mandatory hide-scrollbar" data-id="element-357">
          {testimonials.map((t, i) => <div key={i} className="min-w-[300px] sm:min-w-0 flex-1 bg-beige rounded-lg p-6 shadow-sm snap-center border border-beige-dark" data-id="element-358">
              <div className="flex items-center gap-4 mb-4" data-id="element-359">
                <div className="w-12 h-12 rounded-full bg-gold text-white flex items-center justify-center font-serif font-bold text-lg" data-id="element-360">
                  {t.initials}
                </div>
                <div data-id="element-361">
                  <div className="flex text-gold mb-1" data-id="element-362">
                    {[...Array(5)].map((_, idx) => <Star key={idx} className="w-3.5 h-3.5 fill-current" data-id="element-363" />)}
                  </div>
                  <p className="text-sm font-semibold text-charcoal" data-id="element-364">
                    {t.name}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-365">{t.location}</p>
                </div>
              </div>
              <p className="text-gray-700 italic text-sm leading-relaxed" data-id="element-366">
                "{t.quote}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}